import { render, staticRenderFns } from "./narcoticAdminEditCard.vue?vue&type=template&id=b04b3622"
import script from "./narcoticAdminEditCard.vue?vue&type=script&lang=js"
export * from "./narcoticAdminEditCard.vue?vue&type=script&lang=js"
import style1 from "./narcoticAdminEditCard.vue?vue&type=style&index=1&id=b04b3622&prod&lang=css"
import style2 from "./narcoticAdminEditCard.vue?vue&type=style&index=2&id=b04b3622&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports